module.exports = __webpack_public_path__ + "static/img/jindu_title.e105991.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/jindu_title.png
// module id = CWTJ
// module chunks = 0